module.exports = __webpack_public_path__ + "img/tf.e1be76e3.svg";